import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';
import { NzMessageService } from 'ng-zorro-antd/message';
import { ListOption } from 'src/app/interfaces/action';
import { FilterParam } from 'src/app/interfaces/filter-param';
import { FormServices } from 'src/app/services/form.services';
import { HTTPService } from 'src/app/services/http.service';
import { ButtonList } from 'src/app/system-utils/actions-buttons/actions-buttons.component';

export class Types {
    type: string;
    name: string;
    description: string;
}

@Component({
    selector: 'dashboard-filter-configurator',
    templateUrl: './dashboard-filter-configurator.component.html',
    styleUrls: ['./dashboard-filter-configurator.component.scss'],
    standalone: false
})
export class DahsBoardFilterConfigurationComponent implements OnInit {
  selectedIndex: number;
  disableAdd = false;

  constructor(private http: HTTPService,
    private formServices: FormServices,
    private message: NzMessageService,
    @Inject(NZ_MODAL_DATA) public data,
    public modalRef: NzModalRef) { }

  buttonList: ButtonList[] = [];
  @ViewChild('itemForm') public itemForm: NgForm;
  selectedItem: Object = null;

  filter: FilterParam[] = [];
  parameterType;
  parameterName;
  parameterDesc;
  entityOrigem;
  listOptionStr;
  entityOrigemList: { entityName: string, entityDesc: string, apresentationField: string, controlName: string }[] = [];
  visibleParam = false;
  types: Types[] = [];
  editingItem = false;

  getTypeDescription(type) {
    const t = this.types.find(d => d.type == type);
    return t != null ? t.description : "";
  }

  onSelectEntity() {
    if (this.parameterType == 'R') {
      this.parameterName = this.entityOrigemList.find(d => d.entityName == this.entityOrigem)?.controlName;
    } else {
      this.parameterName = null;
    }
  }

  loadInstances() {
    const ob = {
      "entityName": "Mktpdic",
      "sql": `SELECT * FROM VW_REFERENCE WHERE APRESENTATIONFIELD IS NOT NULL`
    };

    this.http.post(ob, 'JsonBrokerServices/findnative', false, true, true).subscribe({
      next: (data) => {
        if (data && data['SQL']) {
          this.entityOrigemList = data['SQL'];
        }
      },
      error: () => {
        this.message.error('Falha ao carregar as entidades de referência.');
      }
    });
  }

  sair() {
    this.modalRef.close();
  }

  ngOnInit(): void {

    this.buttonList.push(
      {
        color: "warn",
        description: "Cancelar",
        action: () => {
          this.sair();
        }
      },
      {
        color: "primary",
        description: "Salvar",
        action: () => {
          this.okFunction();
        }
      });

    // DEEP COPY: o configurador nunca muta o array vivo do dashboard —
    // cancelar simplesmente descarta a cópia
    this.filter = this.data.filter == null ? [] : JSON.parse(JSON.stringify(this.data.filter));

    this.loadInstances();

    this.types = [{ type: "S", name: "VARCHAR", description: "Texto" },
    { type: "D", name: "DATETIME", description: "Data/Hora" },
    { type: "N", name: "FLOAT", description: "Número" },
    { type: "I", name: "INT", description: "Inteiro" },
    { type: "L", name: "SELECT", description: "Opções" },
    { type: "R", name: "SEARCHREFERENCE", description: "Pesquisa" }];

  }

  okFunction() {
    this.modalRef.close(this.filter);
  }

  deleteItem(event: Event, item) {
    event.stopPropagation();
    const i = this.filter.indexOf(item);
    if (i > -1) {
      this.filter.splice(i, 1);
    }
    this.clearItem();
  }

  editItem(item: FilterParam, index: number) {
    this.visibleParam = true;
    this.selectedItem = item;
    this.selectedIndex = index;
    this.parameterDesc = item.desc;
    this.parameterName = item.nome;
    this.parameterType = item.tipo;
    this.entityOrigem = item.entityName;
    this.editingItem = true;

    if (this.parameterType == 'L') {
      if (item.lista != null && item.lista.length > 0) {
        let str = "";

        for (const i of item.lista) {
          if (str == "") {
            str = str + i.value + '=' + i.view;
          } else {
            str = str + "\n" + i.value + '=' + i.view;
          }
        }
        this.listOptionStr = str;
      }
    }

  }

  addItem() {

    if (this.itemForm == null) {
      this.message.error('Preencha os dados do parâmetro antes de salvar.');
      return false;
    }

    if (this.itemForm.invalid) {
      this.message.error(
        this.formServices.getFormErrors(this.itemForm.form,
          [
            { colName: 'pt', colDesc: 'Tipo' },
            { colName: 'pn', colDesc: 'Nome' },
            { colName: 'pd', colDesc: 'Descrição' },
            { colName: 'et', colDesc: 'Entidade' },
          ]));
      return false;
    }

    const ob: FilterParam = {
      nome: this.parameterName,
      desc: this.parameterDesc,
      tipo: this.parameterType,
      lista: []
    };

    if (this.parameterType == 'R') {
      if (this.entityOrigemList.length > 0) {
        ob.entityName = this.entityOrigem;
        const e = this.entityOrigemList.find(d => d.entityName == this.entityOrigem);
        ob.entityDesc = e.entityDesc;
        ob.apresentationField = e.apresentationField;
        ob.controlName = e.controlName;
      }
    }

    if (this.parameterType == 'L') {
      if (this.listOptionStr != null) {
        // lista SEMPRE reconstruída do zero (antes acumulava entre edições)
        const lista: ListOption[] = [];
        const itens: string[] = this.listOptionStr.split('\n');
        for (const item of itens) {
          lista.push({
            value: item.split('=')[0],
            view: item.split('=')[1]
          });
        }
        ob.lista = lista;
      }
    }

    if (this.editingItem) {
      this.filter[this.selectedIndex] = ob;
    } else {
      if (this.filter.findIndex(d => d.nome == this.parameterName) > -1) {
        this.message.error('Já existe filtro com esse nome. Por favor, alterar o nome.');
        return false;
      }

      this.filter.push(ob);
    }

    this.clearItem();
    return true;
  }

  clearItem() {
    this.selectedIndex = -1;
    this.selectedItem = null;
    this.parameterName = null;
    this.parameterDesc = null;
    this.parameterType = null;
    this.entityOrigem = null;
    this.listOptionStr = null;
    this.visibleParam = false;
  }

  cancelEdit() {
    this.disableAdd = false;
    this.visibleParam = false;
    this.clearItem();
  }

  novo() {
    this.editingItem = false;
    this.disableAdd = true;
    this.clearItem();
    this.visibleParam = true;
  }

  salvar() {
    if (this.addItem()) {
      this.disableAdd = false;
      this.visibleParam = false;
    }
  }

}
